import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../axiosBaseQuery";


const lakeApi = createApi({
    reducerPath: "core/lake",
    baseQuery: axiosBaseQuery,
    tagTypes: ["lakeList"],
    endpoints: (builder) => ({
        lakeFindAll: builder.query<{ data: any[]; pagination: any }, string | void>({
            providesTags: ['lakeList'],
            query: (query = '') => ({
                url: "/core/lake" + query,
                method: "GET",
            }),
            transformResponse: (response: any) => {
                return {
                    data: response.data,
                    pagination: response?.pagination,
                };
            },
        }),
        lakeCreate: builder.mutation({
            invalidatesTags: ['lakeList'],
            query: (data) => ({
                url: `/core/lake`,
                method: "POST",
                data,
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
        }),
        lakeUpdate: builder.mutation({
            invalidatesTags: ['lakeList'],
            query: (data) => ({
                url: `/core/lake/${data.get('id')}`,
                method: "PUT",
                data,
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            })
        }),
        lakeUpdateStatus: builder.mutation<void, { id: number; status_id: number }>({
            invalidatesTags: ['lakeList'],
            query: ({ id, status_id }) => ({
                url: `/core/lake/${id}/status`,
                method: "POST",
                data: { status_id }
            })
        }),
        lakeDelete: builder.mutation({
            invalidatesTags: ['lakeList'],
            query: (id) => ({ url: "/core/lake/" + id, method: "DELETE" })
        }),
    })
})

export const { useLakeFindAllQuery, useLakeCreateMutation, useLakeUpdateMutation, useLakeDeleteMutation, useLakeUpdateStatusMutation } = lakeApi;
export { lakeApi };
